import { render, staticRenderFns } from "./AddActivityTemplateDialog.vue?vue&type=template&id=38b1bb7e&scoped=true"
import script from "./AddActivityTemplateDialog.vue?vue&type=script&lang=ts"
export * from "./AddActivityTemplateDialog.vue?vue&type=script&lang=ts"
import style0 from "./AddActivityTemplateDialog.vue?vue&type=style&index=0&id=38b1bb7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b1bb7e",
  null
  
)

export default component.exports